import { render } from "./DADataTableLazy.vue?vue&type=template&id=a25947da"
import script from "./DADataTableLazy.vue?vue&type=script&lang=js"
export * from "./DADataTableLazy.vue?vue&type=script&lang=js"

import "./DADataTableLazy.vue?vue&type=style&index=0&id=a25947da&lang=scss"

import exportComponent from "../../../../../CASRA/saoil/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__